import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Facebook, MapPin, Mail } from "lucide-react";

export default function Footer() {
  const [c, setC] = useState({});
  useEffect(() => { api.get("/content").then(r => setC(r.data.content || {})); }, []);
  return (
    <footer className="mt-16 bg-emerald-950 text-stone-200" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 py-10 grid gap-8 md:grid-cols-3">
        <div>
          <div className="font-serif text-xl text-white mb-2">AGCVS</div>
          <p className="text-sm text-stone-300">{c.association_full_name || "Association de Gestion Cynégétique en Vallée de Somme"}</p>
          <p className="text-xs text-stone-400 mt-2">Association loi 1901</p>
        </div>
        <div className="text-sm space-y-2">
          <div className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 flex-shrink-0" /><span>{c.address || "14 rue de la Vallée, 80132 Cahon, France"}</span></div>
          <div className="flex items-center gap-2"><Mail size={16} /><a href={`mailto:${c.contact_email || "agcvs80@yahoo.com"}`} className="hover:underline" data-testid="footer-email">{c.contact_email || "agcvs80@yahoo.com"}</a></div>
          <a href={c.facebook_url || "https://www.facebook.com/share/g/1DEc3um79M/"} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-2 hover:underline" data-testid="footer-facebook">
            <Facebook size={16}/> Retrouvez davantage de photos sur notre groupe Facebook
          </a>
        </div>
        <div className="text-xs text-stone-400 space-y-1">
          <a href="/mentions-legales" className="block hover:text-white">Mentions légales</a>
          <a href="/confidentialite" className="block hover:text-white">Politique de confidentialité</a>
          <div className="pt-4 text-stone-500">© {new Date().getFullYear()} AGCVS</div>
        </div>
      </div>
    </footer>
  );
}
